export default "__VITE_ASSET__BG$THFZg__"